import { RowSectorTripPatternDto } from "@/dtos";
import { SectorTripPattern } from "@/entities";
import { MapPolygon } from "@/ui/components/maps/common/interfaces/map-polygon";


export const formatRowSectorTripPatternDto = (sectorTripPatterns: SectorTripPattern[]): RowSectorTripPatternDto[] => {
    return sectorTripPatterns.map((x) => {
        const row: RowSectorTripPatternDto = {
            ...x,
            active: (x.is_active) ? 'Activo' : 'Inactivo',
            sector_label: x.sector.name
        }

        return row;
    });
}

export const formatGeofenceSectorTripPatternDto = (sectorTripPatterns: SectorTripPattern[]): MapPolygon[] => {
    return sectorTripPatterns.map((x, i) => {
        const geofence: MapPolygon = {
            identification: x.sector.name,
            coordinates: x.sector.geofence.coordinates,
            type: `geofece-${(i + 1)}`
        }

        return geofence;
    });
}